import { useMutation } from "@tanstack/react-query";
import {
  mvpApiCreateReviewTasks,
  type MvpApiCreateReviewTasksResponse,
  type ReviewTaskCreateBatchSchema,
} from "@augmodo/lebron-browser-client";

export function useCreateReviewTasks() {
  return useMutation({
    mutationFn: async (
      payload: ReviewTaskCreateBatchSchema,
    ): Promise<MvpApiCreateReviewTasksResponse> => {
      const response = await mvpApiCreateReviewTasks({
        body: payload,
      });

      if (response.error) {
        throw new Error(`Failed to create job: ${response.error}`);
      }

      return response.data as MvpApiCreateReviewTasksResponse;
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      console.error("Job creation failed:", error);
    },
  });
}
